"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventSystem = void 0;
var EventField_1 = require("./EventField");
var EventBase_1 = require("./EventBase");
var EventTelemetryTracking_1 = require("./EventTelemetryTracking");
var EventWithAllFields_1 = require("./EventWithAllFields");
var EventSystem = (function () {
    function EventSystem(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            this.fields = [];
            return;
        }
        this.id = data.id;
        this.name = data.name;
        this.description = typeof data.description !== 'undefined' ? data.description : undefined;
        this.telemetryTracking = typeof data.telemetryTracking !== 'undefined' ? new EventTelemetryTracking_1.EventTelemetryTracking(data.telemetryTracking) : undefined;
        this.meta = typeof data.meta !== 'undefined' ? Object.keys(data.meta).reduce(function (previous, current) { previous[current] = data.meta[current]; return previous; }, {}) : undefined;
        this.fields = data.fields.map(function (e) { return EventField_1.EventFieldHelpers.deserialize(e); });
    }
    EventSystem.prototype.getPackageName = function () { return EventSystem.PackageName; };
    EventSystem.prototype.getClassName = function () { return EventSystem.ClassName; };
    EventSystem.prototype.getFullClassName = function () { return EventSystem.FullClassName; };
    Object.defineProperty(EventSystem.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field id is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field id expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field id is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field id is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field id is expected to be not greater than 4294967295, got ' + value);
            }
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSystem.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSystem.prototype, "description", {
        get: function () {
            return this._description;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._description = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field description expects type string, got ' + value);
            }
            this._description = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSystem.prototype, "telemetryTracking", {
        get: function () {
            return this._telemetryTracking;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._telemetryTracking = undefined;
                return;
            }
            this._telemetryTracking = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSystem.prototype, "meta", {
        get: function () {
            return this._meta;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._meta = undefined;
                return;
            }
            this._meta = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventSystem.prototype, "fields", {
        get: function () {
            return this._fields;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field fields is not optional');
            }
            this._fields = value;
        },
        enumerable: false,
        configurable: true
    });
    EventSystem.prototype.toEventWithAllFieldsSerialized = function () {
        var _this = this;
        return {
            id: this.id,
            name: this.name,
            description: typeof this.description !== 'undefined' ? this.description : undefined,
            telemetryTracking: typeof this.telemetryTracking !== 'undefined' ? this.telemetryTracking.serialize() : undefined,
            meta: typeof this.meta !== 'undefined' ? Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {}) : undefined,
            fields: this.fields.map(function (e) { return EventField_1.EventFieldHelpers.serialize(e); })
        };
    };
    EventSystem.prototype.toEventWithAllFields = function () {
        return new EventWithAllFields_1.EventWithAllFieldsStruct(this.toEventWithAllFieldsSerialized());
    };
    EventSystem.prototype.toEventBaseSerialized = function () {
        var _this = this;
        return {
            id: this.id,
            name: this.name,
            description: typeof this.description !== 'undefined' ? this.description : undefined,
            telemetryTracking: typeof this.telemetryTracking !== 'undefined' ? this.telemetryTracking.serialize() : undefined,
            meta: typeof this.meta !== 'undefined' ? Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {}) : undefined
        };
    };
    EventSystem.prototype.toEventBase = function () {
        return new EventBase_1.EventBaseStruct(this.toEventBaseSerialized());
    };
    EventSystem.prototype.loadEventWithAllFieldsSerialized = function (slice) {
        this.id = slice.id;
        this.name = slice.name;
        this.description = typeof slice.description !== 'undefined' ? slice.description : undefined;
        this.telemetryTracking = typeof slice.telemetryTracking !== 'undefined' ? new EventTelemetryTracking_1.EventTelemetryTracking(slice.telemetryTracking) : undefined;
        this.meta = typeof slice.meta !== 'undefined' ? Object.keys(slice.meta).reduce(function (previous, current) { previous[current] = slice.meta[current]; return previous; }, {}) : undefined;
        this.fields = slice.fields.map(function (e) { return EventField_1.EventFieldHelpers.deserialize(e); });
    };
    EventSystem.prototype.loadEventWithAllFields = function (slice) {
        this.loadEventWithAllFieldsSerialized(slice.serialize());
    };
    EventSystem.prototype.loadEventBaseSerialized = function (slice) {
        this.id = slice.id;
        this.name = slice.name;
        this.description = typeof slice.description !== 'undefined' ? slice.description : undefined;
        this.telemetryTracking = typeof slice.telemetryTracking !== 'undefined' ? new EventTelemetryTracking_1.EventTelemetryTracking(slice.telemetryTracking) : undefined;
        this.meta = typeof slice.meta !== 'undefined' ? Object.keys(slice.meta).reduce(function (previous, current) { previous[current] = slice.meta[current]; return previous; }, {}) : undefined;
    };
    EventSystem.prototype.loadEventBase = function (slice) {
        this.loadEventBaseSerialized(slice.serialize());
    };
    EventSystem.prototype.serialize = function () {
        var _this = this;
        return {
            id: this.id,
            name: this.name,
            description: typeof this.description !== 'undefined' ? this.description : undefined,
            telemetryTracking: typeof this.telemetryTracking !== 'undefined' ? this.telemetryTracking.serialize() : undefined,
            meta: typeof this.meta !== 'undefined' ? Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {}) : undefined,
            fields: this.fields.map(function (e) { return EventField_1.EventFieldHelpers.serialize(e); })
        };
    };
    EventSystem.PackageName = 'net.playq.octopus2.analytics';
    EventSystem.ClassName = 'EventSystem';
    EventSystem.FullClassName = 'net.playq.octopus2.analytics.EventSystem';
    return EventSystem;
}());
exports.EventSystem = EventSystem;
EventWithAllFields_1.EventWithAllFieldsStruct.register(EventSystem.FullClassName, EventSystem);
EventBase_1.EventBaseStruct.register(EventSystem.FullClassName, EventSystem);
var irt_1 = require("@playq/irt");
irt_1.Introspector.register(EventSystem.FullClassName, {
    full: EventSystem.FullClassName,
    short: EventSystem.ClassName,
    package: EventSystem.PackageName,
    type: irt_1.IntrospectorTypes.Data,
    ctor: function () { return new EventSystem(); },
    fields: [
        {
            name: 'id',
            accessName: 'id',
            type: { intro: irt_1.IntrospectorTypes.U32 }
        },
        {
            name: 'name',
            accessName: 'name',
            type: { intro: irt_1.IntrospectorTypes.Str }
        },
        {
            name: 'description',
            accessName: 'description',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Str } }
        },
        {
            name: 'telemetryTracking',
            accessName: 'telemetryTracking',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.octopus2.analytics.EventTelemetryTracking' } }
        },
        {
            name: 'meta',
            accessName: 'meta',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Map, key: { intro: irt_1.IntrospectorTypes.Str }, value: { intro: irt_1.IntrospectorTypes.Str } } }
        },
        {
            name: 'fields',
            accessName: 'fields',
            type: { intro: irt_1.IntrospectorTypes.List, value: { intro: irt_1.IntrospectorTypes.Adt, full: 'net.playq.octopus2.analytics.EventField' } }
        }
    ]
});
//# sourceMappingURL=EventSystem.js.map